import {WalletAdapterNetwork} from '@solana/wallet-adapter-base';


const config = {
  TREASURY_ADDRESS: 'Be7f72rHrDQxWdG3TkS86ewC8xZnQTR4XYrKTgofeooT',
  SOLANA_NETWORK: WalletAdapterNetwork.Mainnet,
  //SOLANA_RPC_HOST: 'https://dark-bitter-frost.solana-mainnet.quiknode.pro/e255c4fa153e061e99956ee9d535d7fde841757a/',
  SOLANA_RPC_HOST: 'https://ssc-dao.genesysgo.net/',
  OG_CHEFS_CANDY_MACHINE_ID: '7MCFP3bBjXKwCZR9wDHUUunh4qDQE2LYAPSvuuY5pdWS',
  TRANSACTION_TIMEOUT: 600000,
  IS_MINT_ACTIVE: true,
  IS_STAKING_ACTIVE: true,
  IS_SUPER_OG_ACTIVE: true,
  IS_RAFFLES_ACTIVE: true,
  //GAME_SERVER_BASE_URL: 'http://localhost:3001',
  GAME_SERVER_BASE_URL: 'https://metakitchenapi.onrender.com',
}


export default config;
